import React from 'react';
import { Link } from 'react-router-dom';
import './navfoot.css';

export default function Footer(){
    return (
        <div className='foot'>
            <p>This application is not affiliated or owned by the official CodeNinjas whatsoever</p>
            <p>For the use of the CodeNinjas Rocklin-Folsom-Roseville locations only</p>
            <p>Created by Jayden Tan 2024</p>
        </div>
    )
}